import { track } from '../analytics/datalayer'
import { appendFormToken } from './formToken'

/** CTAs, dock flotante y formulario fallback. */
export function initConversion(): void {
  // Tracking de todos los CTAs marcados
  document.querySelectorAll<HTMLAnchorElement>('[data-cta]').forEach((a) => {
    a.addEventListener('click', () => {
      const loc = a.dataset.cta ?? 'unknown'
      if (loc.startsWith('whatsapp')) track({ event: 'whatsapp_click', cta_location: loc })
      else track({ event: 'cta_click', cta_location: loc })
    })
  })

  // Dock: visible tras salir del hero, oculto en la salida (el CTA gigante manda)
  const dock = document.getElementById('cta-dock')
  const hero = document.querySelector('[data-chamber="hero"]')
  const salida = document.querySelector('[data-chamber="salida"]')
  if (dock && hero && salida) {
    dock.hidden = false
    let pastHero = false
    let inSalida = false
    const apply = () => dock.classList.toggle('visible', pastHero && !inSalida)
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; apply() }, { threshold: 0.1 })
      .observe(hero)
    new IntersectionObserver(([e]) => { inSalida = e.isIntersecting; apply() }, { threshold: 0.05 })
      .observe(salida)
  }

  // Formulario: time-trap + envío AJAX con fallback nativo
  const form = document.getElementById('contact-form') as HTMLFormElement | null
  if (form) {
    const ts = form.querySelector<HTMLInputElement>('input[name="ts"]')
    if (ts) ts.value = String(Date.now())

    form.addEventListener('submit', async (ev) => {
      ev.preventDefault()
      const status = ensureStatus(form)
      const data = new FormData(form)
      appendFormToken(data)
      try {
        const res = await fetch(form.action, { method: 'POST', body: data })
        const json = (await res.json()) as { ok: boolean; error?: string }
        if (!json.ok) throw new Error(json.error ?? 'error')
        track({ event: 'form_submit', form_id: 'contact' })
        status.textContent = 'Mensaje enviado. Te respondemos dentro del día.'
        status.style.color = '#1a5d1a'
        form.reset()
        if (ts) ts.value = String(Date.now())
      } catch {
        status.textContent = 'No pudimos enviar el mensaje. Escríbenos a hola@jalapenos.cl o por WhatsApp.'
        status.style.color = '#7a1f1f'
      }
    })
  }
}

function ensureStatus(form: HTMLFormElement): HTMLParagraphElement {
  let el = form.querySelector<HTMLParagraphElement>('.form-status')
  if (!el) {
    el = document.createElement('p')
    el.className = 'form-status'
    el.setAttribute('role', 'status')
    form.appendChild(el)
  }
  return el
}
